<template>
  <div class="reminder-wrapper" @click="check">
    <RemainingDays :data="selectedData" class="reminder" />
    <RemainingBudget :data="selectedData" class="reminder" />
    <TodayBuying :data="selectedData" class="reminder" />
    <!-- <Reminder -->
    <!-- :title="'残り予算'" -->
    <!-- :unit="'円'" -->
    <!-- :data="selectedData.remainingBudget" -->
    <!-- :rawData="selectedData" -->
    <!-- :colorChangeMethod="remainingDays" -->
    <!-- /> -->
  </div>
</template>

<script>
import RemainingDays from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/RemainingDays'
import RemainingBudget from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/RemainingBudget'
import TodayBuying from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/TodayBuying'
import { getters } from '@/vuex/modules/progressReport/constants'

export default {
  name: 'ReminderContainer',
  components: { RemainingDays, RemainingBudget, TodayBuying },
  methods: {
    check() {
      console.log(this.selectedData)
    },
  },
  computed: {
    selectedData() {
      // dummy
      // return {
      //   ioLifetimeBudget: 74236,
      //   remainingDays: 0,
      //   revenueBuyingCurrency: 29209.20233,
      //   ioBillingPeriodIds: [10253],
      //   ioBillingPeriodStartDate: '2019-02-13',
      //   dailyBuyingCurrencyPlan: 35026.79767,
      //   insertionOrder: 'エースコンタクト',
      //   yesterdayBudgetProgress: 0.08996538620768525,
      //   insertionOrderBudgetProgress: 0.45471701740457066,
      //   yesterdayBuyingCurrency: 1575.59969,
      //   insertionOrderId: 236,
      //   ioBillingPeriodEndDate: '2019-02-28',
      //   remainingBudget: 35026.79767,
      //   BPIds: [
      //     {
      //       BPId: 8673,
      //       selected: false,
      //       startDate: '2019-01-01',
      //       endDate: '2019-01-31',
      //     },
      //     {
      //       BPId: 10253,
      //       selected: true,
      //       startDate: '2019-02-13',
      //       endDate: '2019-02-28',
      //     },
      //     {
      //       BPId: 8666,
      //       selected: false,
      //       startDate: '2018-04-21',
      //       endDate: '2018-04-26',
      //     },
      //     {
      //       BPId: 8657,
      //       selected: false,
      //       startDate: '2017-09-13',
      //       endDate: '2017-09-30',
      //     },
      //     {
      //       BPId: 8658,
      //       selected: false,
      //       startDate: '2017-10-05',
      //       endDate: '2017-10-31',
      //     },
      //     {
      //       BPId: 8659,
      //       selected: false,
      //       startDate: '2017-11-16',
      //       endDate: '2017-11-30',
      //     },
      //     {
      //       BPId: 8660,
      //       selected: false,
      //       startDate: '2017-12-09',
      //       endDate: '2017-12-31',
      //     },
      //     {
      //       BPId: 8665,
      //       selected: false,
      //       startDate: '2018-04-11',
      //       endDate: '2018-04-16',
      //     },
      //     {
      //       BPId: 8669,
      //       selected: false,
      //       startDate: '2018-09-03',
      //       endDate: '2018-09-30',
      //     },
      //     {
      //       BPId: 8663,
      //       selected: false,
      //       startDate: '2018-03-01',
      //       endDate: '2018-03-07',
      //     },
      //     {
      //       BPId: 8664,
      //       selected: false,
      //       startDate: '2018-03-15',
      //       endDate: '2018-03-22',
      //     },
      //     {
      //       BPId: 8668,
      //       selected: false,
      //       startDate: '2018-08-01',
      //       endDate: '2018-08-31',
      //     },
      //     {
      //       BPId: 8667,
      //       selected: false,
      //       startDate: '2018-07-17',
      //       endDate: '2018-07-31',
      //     },
      //     {
      //       BPId: 8661,
      //       selected: false,
      //       startDate: '2018-01-12',
      //       endDate: '2018-01-31',
      //     },
      //     {
      //       BPId: 8662,
      //       selected: false,
      //       startDate: '2018-02-09',
      //       endDate: '2018-02-28',
      //     },
      //     {
      //       BPId: 8670,
      //       selected: false,
      //       startDate: '2018-10-03',
      //       endDate: '2018-10-31',
      //     },
      //     {
      //       BPId: 8671,
      //       selected: false,
      //       startDate: '2018-11-02',
      //       endDate: '2018-11-30',
      //     },
      //     {
      //       BPId: 8672,
      //       selected: false,
      //       startDate: '2018-12-01',
      //       endDate: '2018-12-31',
      //     },
      //   ],
      // }
      return this.$store.getters[getters.IOProgressData]
    },
  },
}
</script>

<style scoped lang="scss">
.reminder-wrapper {
  display: flex;
}

.reminder {
  background-color: #ffffff;
}
</style>
